import axios from "axios";
import { apiEndpoint } from "utils/configs";

// ----------------------------------------------------------------------

export function handleResponse(res) {
  if (!res.data) {
    return Promise.reject(new Error("Something went wrong"));
  } else {
    return Promise.resolve(res.data);
  }
}

// This file seems not to be used
const axiosInstance = axios.create({
  baseURL: apiEndpoint,
  withCredentials: true,
});

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    return Promise.reject(
      (error.response &&
        error.response.data && {
          message: error.response.data.description,
          ...error.response.data,
        }) ||
        error ||
        "Something went wrong",
    );
  },
);

export default axiosInstance;
